import { Button } from 'aimo-ui';
import useAfterAuthenticationRedirect from 'hooks/useAfterAuthenticationRedirect';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useActiveElementStore } from 'stores/activeElementStore';
import { StyledWrapper } from 'styles/ContainerStyles';
import { isWeb } from 'utils/deviceUtils';
import { testIdentifiers } from 'utils/testIdentifiers';
import { useUiStore } from 'stores/uiStore';

type StaffMemberSignInPromptProps = {
  testID: string;
};

const StaffMemberSignInPrompt: React.FC<StaffMemberSignInPromptProps> = ({
  testID,
}) => {
  const { t } = useTranslation();
  const parkingZoneUid = useActiveElementStore((state) => state.activeElement);
  const { navigateToAuthentication, setReturnRedirectToBuyShortTermParking } =
    useAfterAuthenticationRedirect();

  const handleSignIn = useCallback(async () => {
    useUiStore.getState().setSheetModal('');
    if (parkingZoneUid) {
      setReturnRedirectToBuyShortTermParking(parkingZoneUid);
    }
    await navigateToAuthentication(isWeb);
  }, [
    navigateToAuthentication,
    parkingZoneUid,
    setReturnRedirectToBuyShortTermParking,
  ]);

  return (
    <StyledWrapper center={isWeb} maxWidth={isWeb ? 450 : undefined}>
      <Button
        {...testIdentifiers(testID)}
        text={t('parking.notSignedIn.button.long')}
        size="l"
        buttonType="secondary"
        onPress={handleSignIn}
      />
    </StyledWrapper>
  );
};

export default StaffMemberSignInPrompt;
